import React from 'react';

import GamePage from './components/gamePage.js';

function App() {
  return (
    <div>
      <GamePage />
    </div>
  );
}

export default App;
